import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import DesignType from '../../static/images/questtypes/icon_design.svg'
import DiscoveryType from '../../static/images/questtypes/icon_discovery.svg'
import PracticeType from '../../static/images/questtypes/icon_practice.svg'
import ReflectionType from '../../static/images/questtypes/icon_reflection.svg'

const TypeIcon = styled.div`
  background-repeat: no-repeat;
  background-size: 100%;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
`

const DesignTypeIcon = styled(TypeIcon)`
  background-image: url(${DesignType});
`

const DiscoveryTypeIcon = styled(TypeIcon)`
  background-image: url(${DiscoveryType});
`

const PracticeTypeIcon = styled(TypeIcon)`
  background-image: url(${PracticeType});
`

const ReflectionTypeIcon = styled(TypeIcon)`
  background-image: url(${ReflectionType});
`

const QuestTypeIcon = props => {
  let icon = null
  switch (props.id) {
    case 1: {
      icon = <DiscoveryTypeIcon {...props} />
      break
    }
    case 2: {
      icon = <PracticeTypeIcon {...props} />
      break
    }
    case 3: {
      icon = <DesignTypeIcon {...props} />
      break
    }
    case 4: {
      icon = <ReflectionTypeIcon {...props} />
      break
    }
  }
  return <span className="quest-type-icon">{icon}</span>
}

QuestTypeIcon.defaultProps = {
  size: 25
}

QuestTypeIcon.propTypes = {
  id: PropTypes.number.isRequired,
  size: PropTypes.number
}

export default QuestTypeIcon



// WEBPACK FOOTER //
// ./src/components/mini/QuestTypeIcon.js